"use strict";

exports.__esModule = true;
exports.getDataItemLabel = getDataItemLabel;
function getDataItemLabel(dataItem) {
  return dataItem.type + " " + dataItem.name + (dataItem.units ? " - (" + dataItem.units + ")" : "");
}